<template>
  <b-modal
    ref="modal"
    title="Usuwanie rezerwacji"
    centered
  >
    Czy na pewno chcesz usunąć tę rezerwację?

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <div>
          <b-button variant="secondary" @click="hide()">
            Anuluj
          </b-button>
        </div>
        <div>
          <b-button
            variant="danger"
            :disabled="deleteReservationForm.processing"
            @click="deleteReservation(event.reservation.id)"
          >
            <b-icon icon="x" />
            Usuń rezerwację
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    item: Object,
    event: Object,
  },
  data() {
    return {
      deleteReservationForm: this.$inertia.form({}),
    }
  },
  methods: {
    deleteReservation(reservationId) {
      this.deleteReservationForm.delete(this.route('reservations.destroy', reservationId), {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => this.hide()
      })
    },
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
  },
}
</script>
